import { DatePicker, TimePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { DataDeclarationVM } from 'civil-status/view-models/form-declaration-icaro';
import { FormikErrors, FormikTouched } from 'formik';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';

interface FormProps {
  disabled?: boolean;
  values?: DataDeclarationVM;
  errors?: FormikErrors<DataDeclarationVM>;
  touched?: FormikTouched<DataDeclarationVM>;
  onChange: (
    key: keyof DataDeclarationVM,
    value: DataDeclarationVM[keyof DataDeclarationVM]
  ) => void;
  isRejectionState?: boolean;
}

const FormComponent = ({
  disabled,
  values,
  errors,
  touched,
  onChange,
  isRejectionState,
}: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Tipo dichiarazione"
          aria-label="Tipo dichiarazione"
          id="typeDeclaration"
          name="typeDeclaration"
          fullWidth
          disabled={disabled}
          helperText={errors?.typeDeclaration}
          error={touched?.typeDeclaration && Boolean(errors?.typeDeclaration)}
          type="text"
          variant="outlined"
          value={values?.typeDeclaration || ''}
          onChange={(event) => {
            onChange('typeDeclaration', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Stato dichiarazione"
          aria-label="Stato dichiarazione"
          id="stateDeclaration"
          name="stateDeclaration"
          fullWidth
          disabled={disabled}
          helperText={errors?.stateDeclaration}
          error={touched?.stateDeclaration && Boolean(errors?.stateDeclaration)}
          type="text"
          variant="outlined"
          value={values?.stateDeclaration || ''}
          onChange={(event) => {
            onChange('stateDeclaration', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data dichiarazione"
          aria-label="Data dichiarazione"
          value={values?.dateDeclaration || null}
          onChange={(date) => {
            onChange('dateDeclaration', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateDeclaration"
              fullWidth
              helperText={errors?.dateDeclaration}
              error={touched?.dateDeclaration && Boolean(errors?.dateDeclaration)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TimePicker
          label="Ora dichiarazione"
          aria-label="Ora dichiarazione"
          value={values?.timeDeclaration || null}
          onChange={(date) => {
            onChange('timeDeclaration', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              id="timeDeclaration"
              {...params}
              fullWidth
              error={touched?.timeDeclaration && Boolean(errors?.timeDeclaration)}
              helperText={errors?.timeDeclaration}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data arrivo in posta"
          aria-label="Data arrivo in posta"
          value={values?.dateArrive || null}
          onChange={(date) => {
            onChange('dateArrive', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateArrive"
              fullWidth
              helperText={errors?.dateArrive}
              error={touched?.dateArrive && Boolean(errors?.dateArrive)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TimePicker
          label="Ora arrivo in posta"
          aria-label="Ora arrivo in posta"
          value={values?.timeArrive || null}
          onChange={(date) => {
            onChange('timeArrive', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              id="timeArrive"
              {...params}
              fullWidth
              error={touched?.timeArrive && Boolean(errors?.timeArrive)}
              helperText={errors?.timeArrive}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Protocollo ospedale"
          aria-label="Protocollo ospedale"
          id="protocolHospital"
          name="protocolHospital"
          fullWidth
          disabled={disabled}
          helperText={errors?.protocolHospital}
          error={touched?.protocolHospital && Boolean(errors?.protocolHospital)}
          type="text"
          variant="outlined"
          value={values?.protocolHospital || ''}
          onChange={(event) => {
            onChange('protocolHospital', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Ospedale"
          aria-label="Ospedale"
          id="hospital"
          name="hospital"
          fullWidth
          disabled={disabled}
          helperText={errors?.hospital}
          error={touched?.hospital && Boolean(errors?.hospital)}
          type="text"
          variant="outlined"
          value={values?.hospital || ''}
          onChange={(event) => {
            onChange('hospital', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Cognome addetto sanitario"
          aria-label="Cognome addetto sanitario"
          id="surnameSanit"
          name="surnameSanit"
          fullWidth
          disabled={disabled}
          helperText={errors?.surnameSanit}
          error={touched?.surnameSanit && Boolean(errors?.surnameSanit)}
          type="text"
          variant="outlined"
          value={values?.surnameSanit || ''}
          onChange={(event) => {
            onChange('surnameSanit', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Nome addetto sanitario"
          aria-label="Nome addetto sanitario"
          id="nameSanit"
          name="nameSanit"
          fullWidth
          disabled={disabled}
          helperText={errors?.nameSanit}
          error={touched?.nameSanit && Boolean(errors?.nameSanit)}
          type="text"
          variant="outlined"
          value={values?.nameSanit || ''}
          onChange={(event) => {
            onChange('nameSanit', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Protocollo attestazione di nascita"
          aria-label="Protocollo attestazione di nascita"
          id="protocol"
          name="protocol"
          fullWidth
          disabled={disabled}
          helperText={errors?.protocol}
          error={touched?.protocol && Boolean(errors?.protocol)}
          type="text"
          variant="outlined"
          value={values?.protocol || ''}
          onChange={(event) => {
            onChange('protocol', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data attestazione di nascita"
          aria-label="Data attestazione di nascita"
          value={values?.dateAttestation || null}
          onChange={(date) => {
            onChange('dateAttestation', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateAttestation"
              fullWidth
              helperText={errors?.dateAttestation}
              error={touched?.dateAttestation && Boolean(errors?.dateAttestation)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Difetto età"
          aria-label="Difetto età"
          id="defectAge"
          name="defectAge"
          fullWidth
          disabled={disabled}
          helperText={errors?.defectAge}
          error={touched?.defectAge && Boolean(errors?.defectAge)}
          type="text"
          variant="outlined"
          value={values?.defectAge || ''}
          onChange={(event) => {
            onChange('defectAge', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Operatore"
          aria-label="Operatore"
          id="operator"
          name="operator"
          fullWidth
          disabled={disabled}
          helperText={errors?.operator}
          error={touched?.operator && Boolean(errors?.operator)}
          type="text"
          variant="outlined"
          value={values?.operator || ''}
          onChange={(event) => {
            onChange('operator', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data ultima operazione"
          aria-label="Data ultima operazione"
          value={values?.dateLastOperation || null}
          onChange={(date) => {
            onChange('dateLastOperation', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateLastOperation"
              fullWidth
              helperText={errors?.dateLastOperation}
              error={touched?.dateLastOperation && Boolean(errors?.dateLastOperation)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Contatore dichiarazioni"
          aria-label="Contatore dichiarazioni"
          id="counter"
          name="counter"
          fullWidth
          disabled={disabled}
          helperText={errors?.counter}
          error={touched?.counter && Boolean(errors?.counter)}
          type="text"
          variant="outlined"
          value={values?.counter || ''}
          onChange={(event) => {
            onChange('counter', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label={`Motivo rifiuto ${isRejectionState ? '*' : ''}`}
          aria-label="Motivo rifiuto"
          id="reasonRefusal"
          name="reasonRefusal"
          fullWidth
          disabled={!isRejectionState}
          helperText={errors?.reasonRefusal}
          error={touched?.reasonRefusal && Boolean(errors?.reasonRefusal)}
          type="text"
          variant="outlined"
          value={values?.reasonRefusal || ''}
          onChange={(event) => {
            onChange('reasonRefusal', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Data Declaration - Form Component';

const Form = memo(FormComponent);

export default Form;
